import Image from "next/image";
import HexagonsBg from "../icons/HexagonsBg";
import StarBg from "../icons/StarBg";

const FeaturedActivitySlide = () => {
  return (
    <div
      className={`relative mt-4 flex flex-[0_0_100%] overflow-hidden rounded-3xl border bg-BG-30 small:w-[736px] medium:w-[976px] large:w-[1392px]`}
    >
      <HexagonsBg
        fill="#83FBA3"
        className="absolute bottom-0 left-0 shrink-0"
      />
      <div className="relative flex h-full w-full flex-col justify-center px-6 small:w-[50%] small:pl-10 small:pr-0 medium:pl-[64px]">
        <StarBg
          fill="#83FBA3"
          className="absolute left-11 top-5 h-6 w-6 shrink-0"
        />

        <StarBg
          fill="#83FBA3"
          className="absolute bottom-9 right-[20%] h-8 w-8 shrink-0"
        />
        <div className="mt-4 font-teodor text-4xl leading-none small:text-[56px] medium:text-[64px]">
          Resources educators can use today
        </div>

        <p className="z-1 mt-6 text-base font-normal not-italic small:mt-8 small:w-[336px] small:text-xl medium:w-[408px] medium:text-2xl large:w-[535px] large:leading-8">
          Our activities help you bring the XQ Competencies into your classroom
          right away, in any content area or discipline.
        </p>
      </div>

      <div className="relative hidden small:block small:w-[50vw]">
        <StarBg
          fill="#83FBA3"
          className="absolute bottom-[20%] left-0 h-12 w-12 shrink-0"
        />

        <Image
          src="/assets/featured_activity.png"
          className="h-full w-full object-cover object-left"
          alt="overview-image"
          width={1440}
          height={880}
        />
      </div>
    </div>
  );
};

export default FeaturedActivitySlide;
